import React from 'react';

class TaskPlaceholder extends React.Component {
    render() {
        return (
            <div className="card">
                <div className="card-block">
                    You have no tasks according to your filter criteria
                                                </div>
            </div>
        )
    }
}

export default TaskPlaceholder


// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Task/TaskPlaceholder.js